var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJudge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "judge"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.675 16.0497C16.5167 16.0497 16.3584 15.9914 16.2334 15.8664L12.1084 11.7414C11.8667 11.4997 11.8667 11.0997 12.1084 10.858C12.35 10.6164 12.75 10.6164 12.9917 10.858L17.1167 14.983C17.3584 15.2247 17.3584 15.6247 17.1167 15.8664C16.9917 15.9914 16.8334 16.0497 16.675 16.0497Z",
    fill: "#026C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42457 15.3581C7.81624 15.3581 7.2329 15.1164 6.8079 14.6831L3.27456 11.1497C2.3829 10.2581 2.3829 8.79972 3.27456 7.90805L9.16624 2.01641C10.0579 1.12474 11.5162 1.12474 12.4079 2.01641L15.9412 5.54973C16.3746 5.98306 16.6162 6.55807 16.6162 7.1664C16.6162 7.77473 16.3746 8.35807 15.9412 8.78307L10.0496 14.6747C9.61624 15.1247 9.04124 15.3581 8.42457 15.3581ZM10.7829 2.59972C10.5162 2.59972 10.2496 2.69972 10.0496 2.90805L4.15791 8.79973C3.74958 9.20806 3.74958 9.86638 4.15791 10.2747L7.69123 13.8081C8.0829 14.1997 8.76624 14.1997 9.16624 13.8081L15.0579 7.9164C15.2579 7.7164 15.3662 7.45806 15.3662 7.18306C15.3662 6.90806 15.2579 6.64139 15.0579 6.44972L11.5246 2.9164C11.3162 2.69973 11.0496 2.59972 10.7829 2.59972Z",
    fill: "#026C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 18.1247H1.66669C1.32502 18.1247 1.04169 17.8414 1.04169 17.4997C1.04169 17.158 1.32502 16.8747 1.66669 16.8747H6.66669C7.00835 16.8747 7.29169 17.158 7.29169 17.4997C7.29169 17.8414 7.00835 18.1247 6.66669 18.1247Z",
    fill: "#026C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3584 13.1163C11.2 13.1163 11.0417 13.058 10.9167 12.933L5.02502 7.04135C4.78335 6.79968 4.78335 6.39968 5.02502 6.15802C5.26669 5.91635 5.66669 5.91635 5.90835 6.15802L11.8 12.0497C12.0417 12.2913 12.0417 12.6913 11.8 12.933C11.6834 13.058 11.5167 13.1163 11.3584 13.1163Z",
    fill: "#026C96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudge);
export default __webpack_public_path__ + "static/media/judge.c663c1baa0f067fb44c6dad2f18da27d.svg";
export { ForwardRef as ReactComponent };